export default __webpack_public_path__ + "static/logo_funcamp-47cb8ef59b6a8b9891cf8d9cffc97d52.png";